import React from 'react';

// Card heights follow FullPrediction (hero, block, tip CTA, odds, compare odds) so the swap does not jump
const PredictionSkeleton = () => (
  <div className="animate-pulse space-y-4">
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-4 md:p-5 min-h-[156px] md:min-h-[135px] flex flex-col justify-center">
      <div className="flex items-center gap-3 md:gap-4">
        <div className="flex items-center gap-2 flex-1">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-200 dark:bg-gray-700" />
          <div className="space-y-1.5">
            <div className="h-4 w-16 md:w-24 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-2 w-10 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        </div>
        <div className="text-center">
          <div className="h-5 w-12 bg-gray-200 dark:bg-gray-700 rounded mx-auto mb-1" />
          <div className="h-2 w-10 bg-gray-200 dark:bg-gray-700 rounded mx-auto" />
        </div>
        <div className="flex items-center gap-2 flex-1 justify-end">
          <div className="space-y-1.5 text-right">
            <div className="h-4 w-16 md:w-24 bg-gray-200 dark:bg-gray-700 rounded ml-auto" />
            <div className="h-2 w-10 bg-gray-200 dark:bg-gray-700 rounded ml-auto" />
          </div>
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-200 dark:bg-gray-700" />
        </div>
      </div>
      <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
        <div className="h-3 w-32 bg-gray-200 dark:bg-gray-700 rounded mx-auto" />
      </div>
    </div>

    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-4 md:p-5 min-h-[142px] md:min-h-[150px]">
      <div className="flex items-center justify-between mb-4">
        <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="flex gap-0.5">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="w-2 h-5 bg-gray-200 dark:bg-gray-700 rounded-full" />
          ))}
        </div>
      </div>
      <div className="bg-gray-50/50 dark:bg-gray-700/30 py-3 px-4 rounded-lg">
        <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded mb-2" />
        <div className="h-4 w-3/4 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
    </div>

    <div className="h-[68px] bg-gray-200 dark:bg-gray-700 rounded-2xl" />

    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-4 md:p-5 min-h-[318px] md:min-h-[314px]">
      <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
      <div className="flex gap-2 md:gap-4 mb-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex-1 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl text-center">
            <div className="h-2 w-12 bg-gray-200 dark:bg-gray-600 rounded mx-auto mb-2" />
            <div className="h-7 w-14 bg-gray-200 dark:bg-gray-600 rounded mx-auto" />
          </div>
        ))}
      </div>
      <div className="h-12 w-full bg-gray-200 dark:bg-gray-700 rounded-xl" />
    </div>

    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-4 md:p-5 min-h-[346px] md:min-h-[314px]">
      <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
      <div className="space-y-2">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="flex gap-2">
            <div className="h-8 flex-1 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-8 w-12 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-8 w-12 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-8 w-12 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default PredictionSkeleton;
